// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d7946c7","239":"078eca7a","453":"08f86025","455":"f2f1fecf"}[chunkId] + ".chunk.js";
};